<template>
  <ODialog
    ref="dialog"
    :title="$t('pass.delete')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Pass } from '~/_api/models/pass'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref()
const pass = ref<Pass | null>(null)

const info = computed(() => {
  return $i18n.t('components.pass.actions.delete.info', {
    name: pass.value?.name,
    id: pass.value?.idPass,
  })
})

const open = (passItem: Pass) => {
  pass.value = passItem
  dialog.value.open()
}

const confirm = async () => {
  if (!pass.value) return

  emit('update:loading', true)

  try {
    const response = await $api.pass.delete(pass.value)
    emit('update:loading', false)

    if (response.success) {
      $notification.toast({
        title: $i18n.t('pass.deletedSuccess'),
        text: $i18n.t('components.pass.actions.delete.successInfo', { name: pass.value.name }),
      })

      emit('success')

      return true
    }
  } catch (e) {
    $notification.toast({
      title: $i18n.t('components.pass.actions.delete.error'),
      text: $i18n.t('components.pass.actions.delete.errorInfo', { name: pass.value?.name }),
    })

    emit('error')
  }
}

defineExpose({
  open,
})
</script>
